import React from "react";
import ConfirmModal from "../../../../../../components/modal/ConfirmModal";

// "Are you sure…?" popup on My Page (save an edit, log out…). Same look as the
// edit / cancel booking confirmations — see components/modal/ConfirmModal.
//
// confirmVariant "danger" (red) is for leaving / destructive actions such as
// log out; the default "primary" (gold) is for saving.
const ModalConfirmation = ({
  text = "",
  cancel = "No",
  proceed = "Yes",
  handleClose,
  handleContinue,
  show,
  confirmVariant = "primary",
  confirmIcon = null,
}) => {
  return (
    <ConfirmModal
      show={show}
      onClose={handleClose}
      onConfirm={handleContinue}
      title={text}
      cancelLabel={cancel}
      confirmLabel={proceed}
      confirmVariant={confirmVariant}
      confirmIcon={confirmIcon}
    />
  );
};

export default ModalConfirmation;
